import { render, staticRenderFns } from "./DocumentsBottom.vue?vue&type=template&id=281a7252&lang=pug"
import script from "./DocumentsBottom.vue?vue&type=script&lang=js"
export * from "./DocumentsBottom.vue?vue&type=script&lang=js"
import style0 from "./DocumentsBottom.vue?vue&type=style&index=0&id=281a7252&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports